import DropDownFilterCell from "../../../components/GridCell/GridDropDownFilterCell";
import GridDateFormatCell from "../../../components/GridCell/GridDateFormatCell";
import { t } from "i18next";

export const guestEventGridColumns = [
  {
    field: "etkinliK_ADI",
    title_key: "event_name",
    width: "320px",
    filterable: true,
  },
  {
    field: "aktiF_PASIF",
    title_key: "status",
    width: "140px",
    filterable: true,
    filterCell: (props) => (
      <DropDownFilterCell
        data={[
          { value: "AKTIF", text: t("aktif") },
          { value: "PASIF", text: t("pasif") },
        ]}
        {...props}
      />
    ),
    cell: (props) => {
      const value = props.dataItem.aktiF_PASIF;
      return <td>{value ? t(value.toLowerCase()) : "-"}</td>;
    },
  },
  {
    field: "olusturaN_AD_SOYAD",
    title_key: "created_by",
    width: "220px",
    filterable: true,
  },
  {
    field: "crE_DATE",
    title_key: "created_date",
    width: "200px",
    cell: (props) => GridDateFormatCell(props, t("date_formats.shortDateTime")),
    filterable: false,
  },
];
